webpackJsonp([58411574672382],{

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _ContactFind = __webpack_require__(69);
	
	var _ContactFind2 = _interopRequireDefault(_ContactFind);
	
	var _SiteConfig = __webpack_require__(6);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Header = __webpack_require__(12);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Clear = __webpack_require__(34);
	
	var _Clear2 = _interopRequireDefault(_Clear);
	
	var _SocialLinks = __webpack_require__(16);
	
	var _SocialLinks2 = _interopRequireDefault(_SocialLinks);
	
	var _SEO = __webpack_require__(14);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _HeaderPage = __webpack_require__(15);
	
	var _HeaderPage2 = _interopRequireDefault(_HeaderPage);
	
	var _Footer = __webpack_require__(11);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _contact = __webpack_require__(103);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _Menu = __webpack_require__(13);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactPage = function (_Component) {
	    _inherits(ContactPage, _Component);
	
	    function ContactPage() {
	        _classCallCheck(this, ContactPage);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ContactPage.prototype.render = function render() {
	        var slug = this.props.pathContext.slug;
	
	
	        var title = "Contacter Integral Service";
	        var description = "On vous répond rapidement !";
	        var goto = "";
	
	        var postNode = {
	            "frontmatter": {
	                "title": title,
	                "description": "Contacter le studio Web spécialisé dans la création d'application web INTEGRAL SERVICE.",
	                "cover": _contact2.default
	            }
	        };
	
	        return _react2.default.createElement(
	            "div",
	            { className: "contact" },
	            _react2.default.createElement(_reactHelmet2.default, { title: title }),
	            _react2.default.createElement(_SEO2.default, { postPath: slug, postNode: postNode, postSEO: true }),
	            _react2.default.createElement(_Menu2.default, null),
	            _react2.default.createElement(_Header2.default, null),
	            _react2.default.createElement(_HeaderPage2.default, { title: title, description: description, picture: _contact2.default }),
	            _react2.default.createElement(_ContactFind2.default, null),
	            _react2.default.createElement(_Clear2.default, null),
	            _react2.default.createElement(_Footer2.default, null)
	        );
	    };
	
	    return ContactPage;
	}(_react.Component);
	
	exports.default = ContactPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-jsx-bf36922b725249df8069.js